export default "__VITE_ASSET__pDJIepIq__"